'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dKind from "./presto.types$-Directive-Kind.js";
var $p;
/** @constructor */
function $c_Lpresto_types$DirectiveKind$$anon$12(_$ordinal$21, \u03b4name$21, outer) {
  this.a9p = 0;
  this.a9o = null;
  this.a9p = _$ordinal$21;
  this.a9o = \u03b4name$21;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$DirectiveKind$$anon$12 as $c_Lpresto_types$DirectiveKind$$anon$12 };
$p = $c_Lpresto_types$DirectiveKind$$anon$12.prototype = new $j_presto$002etypes$0024$002dDirective$002dKind.$h_Lpresto_types$DirectiveKind();
$p.constructor = $c_Lpresto_types$DirectiveKind$$anon$12;
/** @constructor */
function $h_Lpresto_types$DirectiveKind$$anon$12() {
}
export { $h_Lpresto_types$DirectiveKind$$anon$12 as $h_Lpresto_types$DirectiveKind$$anon$12 };
$h_Lpresto_types$DirectiveKind$$anon$12.prototype = $p;
$p.r = (function() {
  return 0;
});
$p.j = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.s = (function() {
  return this.a9o;
});
$p.l = (function() {
  return this.a9o;
});
var $d_Lpresto_types$DirectiveKind$$anon$12 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$DirectiveKind$$anon$12, "presto.types$DirectiveKind$$anon$12", ({
  ZU: 1,
  jL: 1,
  b: 1,
  c: 1,
  a: 1,
  q: 1,
  s: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_types$DirectiveKind$$anon$12 as $d_Lpresto_types$DirectiveKind$$anon$12 };
//# sourceMappingURL=presto.types$-Directive-Kind$$anon$12.js.map
